import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import Modal from 'meinian-package/src/component/modal'
import { FolderTreeWrap } from '../../folderTree'
import './index.less'

export default (props) => {
  const div = props?.root || document.createElement('div')
  return new Promise(() => {
    ReactDOM.render(<MoveFolder {...props} visible container={div} />, div)
  })
}

/**
 *
 * @param {*} type  folder | sample
 * @returns
 */

export const MoveFolder = ({ visible, onCancel, onOk, type = 'folder', title = '移动文件夹至', option = {}, createFolderAuth }) => {
  const [_visible, set_Visible] = useState(visible)
  const { id } = option
  const [_curData, set_curData] = useState({})
  const [value, setValue] = useState(id)

  const _cancel = () => {
    onCancel && onCancel()
    set_Visible(false)
  }
  const _ok = async () => {
    console.log('执行了么额')
    const flag = await onOk?.(_curData, value)
    console.log('flag', flag)
    if (flag === false) {
      return
    }
    set_Visible(false)
  }

  const _onCreate = async (curData, parentId, currentId) => {
    await onOk?.(curData, currentId.id)
    set_Visible(false)
  }
  return <Modal
    style={{ width: '480px' }}
    visible={_visible}
    onCancel={_cancel}
    onOk={_ok}
    title={title}
  >
    <div className="mn-fun-modal-more-folder">
      <FolderTreeWrap
        type={type}
        value={value}
        onChange={(curData, val) => {
          set_curData(curData)
          setValue(val)
        }}
        onCreate={_onCreate}
        createFolderAuth={createFolderAuth}
      />
    </div>
  </Modal>
}
